import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

const MenuButton = ({ transparent }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(prev => !prev);
  const closeMenu = () => setIsOpen(false);

  const positionClass = transparent
    ? "right-[1vh]"
    : "left-[1vh]";
  const buttonStyle = transparent
    ? "bg-blue-400 text-white hover:bg-transparent"
    : "bg-[#f9f9f9] text-blue-400";

  return (
    <div className={`fixed top-[1vh] z-50 ${positionClass}`}>
      <div
        onClick={toggleMenu}
        className={`flex justify-center items-center text-[3vh] rounded-lg w-[6vh] h-[6vh] cursor-pointer ${buttonStyle}`}
      >
        <FontAwesomeIcon icon={faBars} />
      </div>

      {isOpen && (
        <div
          className={`mt-[2vh] w-auto bg-white border rounded-lg shadow-lg max-lg:w-[96vw] max-h-[80vh] p-[1vw] ${transparent ? 'right-0' : 'left-0'} absolute `}
        >
          <ul className="space-y-2 text-left">
            <li><Link to="/dashboard" onClick={closeMenu} className="block px-4 py-2 text-gray-800 hover:bg-gray-100">Dashboard</Link></li>
            <li><Link to="/login" onClick={closeMenu} className="block px-4 py-2 text-gray-800 hover:bg-gray-100">Login</Link></li>
            <li><Link to="/signup" onClick={closeMenu} className="block px-4 py-2 text-gray-800 hover:bg-gray-100">Sign Up</Link></li>
            <li><Link to="/workerlogin" onClick={closeMenu} className="block px-4 py-2 text-gray-800 hover:bg-gray-100">Worker Login</Link></li>
            <li><Link to="/worker-table-view" onClick={closeMenu} className="block px-4 py-2 text-gray-800 hover:bg-gray-100">Worker Table</Link></li>
            <li><Link to="/order-dashboard" onClick={closeMenu} className="block px-4 py-2 text-gray-800 hover:bg-gray-100">Order Dashboard</Link></li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default MenuButton;
